import { render } from "./BasePopup.vue?vue&type=template&id=3bbb8686&scoped=true"
import script from "./BasePopup.vue?vue&type=script&lang=js"
export * from "./BasePopup.vue?vue&type=script&lang=js"

import "./BasePopup.vue?vue&type=style&index=0&id=3bbb8686&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbb8686"]])

export default __exports__